// src/app/inicio-adaptativo/inicio-adaptativo.component.ts
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DeviceService } from 'src/app/services/devices.service';


@Component({
  selector: 'app-inicio-adaptativo',
  template: `
    <app-inicio *ngIf="!(isMobile$ | async)"></app-inicio>
    <app-inicio-mobile *ngIf="(isMobile$ | async)"></app-inicio-mobile>
  `
})
export class InicioAdaptativoComponent implements OnInit {
  isMobile$: Observable<boolean>;

  constructor(private deviceService: DeviceService) {
    this.isMobile$ = this.deviceService.isMobile();
  }

  ngOnInit(): void {}
}
